import { recruiterRoleEnum } from 'services/companies/companies.enums'
import { IRegisterUser } from '../auth.types'

export const initialRegisterState: IRegisterUser = {
  email: '',
  firstName: '',
  lastName: '',
  password: '',
  companyName: '',
  role: recruiterRoleEnum.admin,
}
